import { CardContent, Card, Grid, Button, CircularProgress } from '@mui/material';
import ReviewSectionAccordion from 'src/components/ReviewSectionAccordion';
import formatYesNo from 'src/util/formatYesNo';
import LabeledValue from 'src/components/LabeledValue';
import SectionHeader from 'src/components/SectionHeader';
import moment from 'moment';
import { defaultEmptyString, handlePaperlessFlag } from 'src/util/createReviewValues';
import SubFillingDetailsSections from 'src/components/section/SubFillingDetailsSections=';
import { useFilingReview } from 'src/services/pdf';
import { useHistory } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import { useState } from 'react';

export default function BackdoorFilingDetailsSection({ detailInfo }) {
  const filingPDF = useFilingReview();
  const history = useHistory();
  const search = history.location.search;
  const params = new URLSearchParams(search);
  const [loadedPDF, setLoadedPDF] = useState(true);
  const [loadedAssetPDF, setLoadedAssetPDF] = useState(true);
  return (
    <>
      <Grid container flexDirection="column">
        <Grid item>
          <SectionHeader title="Personal Property Web Filing Summary" />
        </Grid>
        <Grid container columnSpacing={2}>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              data-cy="download-pdf"
              disabled={!loadedPDF}
              sx={{
                width: '100%',
                height: '2.25rem',
              }}
              onClick={() =>
                filingPDF.downloadReview(
                  {
                    accountNo: params.get('accountNo'),
                    taxYear: params.get('taxYear'),
                  },
                  setLoadedPDF
                )
              }
              startIcon={<DownloadIcon />}
            >
              {loadedPDF ? 'Download pdf' : <CircularProgress size={'1.25rem'} />}
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              data-cy="download-pdf"
              disabled={!loadedAssetPDF}
              sx={{
                width: '100%',
                height: '2.25rem',
              }}
              onClick={() =>
                filingPDF.downloadAssets(
                  {
                    accountNo: params.get('accountNo'),
                    taxYear: params.get('taxYear'),
                  },
                  setLoadedAssetPDF
                )
              }
              startIcon={<DownloadIcon />}
            >
              {loadedAssetPDF ? 'Download Assets' : <CircularProgress size={'1.25rem'} />}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <ReviewSectionAccordion title={`Submission Details`}>
        <Card sx={{ textAlign: 'left' }}>
          <CardContent>
            <Grid container rowSpacing={2} columnSpacing={4}>
              <Grid item xs={12} md={4} data-cy="Account #">
                <LabeledValue
                  label="Account #"
                  value={defaultEmptyString(detailInfo?.businessInfo?.accountNo)}
                />
              </Grid>
              <Grid item xs={12} md={4} data-cy="Year">
                <LabeledValue
                  label="Year"
                  value={defaultEmptyString(detailInfo?.businessInfo?.taxYear)}
                />
              </Grid>
              <Grid item xs={12} md={4} data-cy="Tax District">
                <LabeledValue
                  label="Tax District"
                  value={defaultEmptyString(detailInfo?.businessInfo?.taxDist)}
                />
              </Grid>
              <Grid item xs={12} md={4} data-cy="Date">
                <LabeledValue
                  label="Date"
                  value={moment(detailInfo?.updatedInfo?.importDate).format('MM/DD/YYYY')}
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Submitted By">
                <LabeledValue
                  label="Submitted By"
                  value={defaultEmptyString(detailInfo?.updatedInfo?.submitterName)}
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Submitters phone">
                <LabeledValue
                  label="Submitters phone"
                  value={defaultEmptyString(detailInfo?.updatedInfo?.submitterPhone)}
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Paperless">
                <LabeledValue
                  label="Paperless"
                  value={handlePaperlessFlag(detailInfo?.updatedInfo?.paperlessFlag)}
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Bypass Itemization">
                <LabeledValue
                  label="Bypass Itemization"
                  value={formatYesNo(
                    defaultEmptyString(detailInfo?.updatedInfo?.bypassItemization)
                  )}
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Tax Exemption Status">
                <LabeledValue
                  label="Tax Exemption Status"
                  value={
                    detailInfo?.updatedInfo?.reqExempt === 'Y'
                      ? 'Applied for Tax Exemption'
                      : 'Not Eligible or Did Not Apply For Tax Exemption'
                  }
                />
              </Grid>

              <Grid item xs={12} md={4} data-cy="Remarks">
                <LabeledValue
                  label="Remarks"
                  value={defaultEmptyString(detailInfo?.updatedInfo?.remarks)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </ReviewSectionAccordion>
      <SubFillingDetailsSections {...detailInfo} />
    </>
  );
}
